<template>
    <div>
        <q-card class="shadow-0">
            <q-card-section class="row justify-between">
                <div class="text-h6">Datos Legales</div>
                <q-btn outline icon="save" label="Guardar" color="primary" class="q-mr-sm"
                    @click="guardarDatosLegales" />
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12 col-md-12">
                        <q-select v-model="cliente.tipo" label="Tipo de cliente" :options="['Física', 'Moral']" outlined
                            dense emit-value map-options />
                    </div>
                    <!-- 👤 Persona Física -->
                    <template v-if="cliente.tipo === 'Física'">
                        <!-- <div class="col-12 col-md-12">
                            <q-input v-model="cliente.ine" label="INE" outlined dense />
                        </div> -->
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.curp" label="CURP" outlined dense />
                        </div>

                        <!-- <div class="col-12 col-md-12">
                            <q-input v-model="cliente.direccion" label="Dirección completa" outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.licencia.numero" label="Número de licencia" outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.licencia.vigencia" label="Vigencia de la licencia" type="date"
                                outlined dense />
                        </div> -->
                    </template>

                    <template v-if="cliente.tipo === 'Moral'">
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.num_escritura" label="Número de Escritura Pública" outlined
                                dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.fecha_constitucion" label="Fecha de constitución" type="date"
                                outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.notario.nombre" label="Nombre del notario/corredor" outlined
                                dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.notario.tipo" label="Tipo de fedatario (Notaría/Correduría)"
                                outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.notario.numero" label="Número de notaría/correduría" outlined
                                dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.notario.distrito" label="Ciudad/Municipio" outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.notario.estado" label="Estado" outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.rpp.lugar" label="Lugar del Registro Público" outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.rpp.folio" label="Folio RPP" outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.rpp.fecha_inscripcion" label="Fecha de inscripción" type="date"
                                outlined dense />
                        </div>
                        <div class="col-12">
                            <div class="text-subtitle2 ">Datos del Representante Legal</div>
                            <q-separator />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.representante.nombre" label="Nombre del representante" outlined
                                dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.representante.num_poder" label="Número de poder notarial" outlined
                                dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.representante.fecha_poder" label="Fecha del poder" type="date"
                                outlined dense />
                        </div>

                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.representante.notario_nombre" label="Nombre del notario" outlined
                                dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.representante.tipo_fedatario" label="Tipo de fedatario" outlined
                                dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.representante.numero_notaria" label="Número de notaría" outlined
                                dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.representante.distrito" label="Distrito" outlined dense />
                        </div>
                        <div class="col-12 col-md-12">
                            <q-input v-model="cliente.representante.estado" label="Estado" outlined dense />
                        </div>
                    </template>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { QSpinnerClock } from 'quasar'
import axios from 'axios'

export default {
    name: 'PerfilCliente',
    data() {
        return {
            cliente: {
                _id: '',
                _id_cliente: '',
                tipo: 'Física',

                // Persona Física
                curp: '',
                direccion: '',

                licencia: {
                    numero: '',
                    vigencia: ''
                },

                // Persona Moral
                num_escritura: '',
                fecha_constitucion: '',
                notario: {
                    nombre: '',
                    tipo: '',
                    numero: '',
                    distrito: '',
                    estado: ''
                },
                rpp: {
                    lugar: '',
                    folio: '',
                    fecha_inscripcion: ''
                },
                representante: {
                    nombre: '',
                    num_poder: '',
                    fecha_poder: '',
                    notario_nombre: '',
                    tipo_fedatario: '',
                    numero_notaria: '',
                    distrito: '',
                    estado: ''
                }
            }
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.auth.clienteStore;
        },
    },
    methods: {
        async guardarDatosLegales() {
            this.cliente._id_cliente = this.usuarioStore._id_cliente
            console.log(this.cliente)
            if (this.cliente.tipo == 'Física') {
                if (this.cliente.curp == '') {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: 'Ingrese la CURP de la persona Física.' })
                    return
                }
            } else {
                if (this.cliente.num_escritura == '' ||
                    this.cliente.fecha_constitucion == '' ||
                    this.cliente.notario.nombre == '' ||
                    this.cliente.notario.tipo == '' ||
                    this.cliente.notario.numero == '' ||
                    this.cliente.notario.distrito == '' ||
                    this.cliente.notario.estado == '' ||
                    this.cliente.rpp.lugar == '' ||
                    this.cliente.rpp.folio == '' ||
                    this.cliente.rpp.fecha_inscripcion == '' ||
                    this.cliente.representante.nombre == '' ||
                    this.cliente.representante.num_poder == '' ||
                    this.cliente.representante.fecha_poder == '' ||
                    this.cliente.representante.notario_nombre == '' ||
                    this.cliente.representante.tipo_fedatario == '' ||
                    this.cliente.representante.numero_notaria == '' ||
                    this.cliente.representante.distrito == '' ||
                    this.cliente.representante.estado == '') {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: 'Ingrese toda la información del formulario.' })
                    return
                }
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })
            try {
                await axios.post('Configuracion/PostDatosLegales', this.cliente)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Datos guardados correctamente' })
            } catch (err) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al actualizar perfil' })
            }
        },
        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetDatosLegalesPorCliente/' + this.usuarioStore._id_cliente)

                if (res.data._id) {
                    this.cliente = res.data
                }
                console.log('res.data', res.data)
            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        },
    },
    mounted() {
        this.obtenerPerfil()
    },
}
</script>